import { ReactNode } from 'react';

import { formatDate } from 'app/services/dates';

type LessonItemProps = {
  lesson: any,
  onClick?: () => void,
  showDate?: boolean,
  showField?: boolean,
  className?: string,
  children?: ReactNode,
}

const getHour = (dateTime: string) => dateTime?.substring(11, 16);

// age group • category • level, only the ones informed
const getLessonInfo = (lesson: any) => {
  const attributes = lesson.attributes;

  return [
    attributes.age_group_formatted,
    attributes.gender_formatted,
    attributes.level_formatted && `Nível ${attributes.level_formatted.toLowerCase()}`,
  ].filter(Boolean);
}

const LessonItem = ({ lesson, onClick, showDate = false, showField = true, className = 'mb-5', children }: LessonItemProps) => {
  const attributes = lesson.attributes;
  const instructors = lesson.relationships?.instructors ?? [];

  return (
    <div
      className={`card card-dashed p-5 w-100 ${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className='d-flex justify-content-between align-items-start'>
        <div className='d-flex flex-column flex-grow-1 min-w-0 me-3'>
          <div className='fs-2 fw-bold'>
            {showDate && <span className='text-primary me-2'>{formatDate(attributes.date)} •</span>}
            {getHour(attributes.start_at)} - {getHour(attributes.finish_at)}
          </div>

          {showField && <div className='fs-6 fw-semibold text-gray-700 pt-1'>
            {lesson.relationships?.field?.attributes?.name}
          </div>}

          {instructors.length > 0 && <div className='fs-7 fw-semibold text-gray-600 pt-1'>
            Professor: {instructors.map((instructor: any) => instructor.attributes.name).join(', ')}
          </div>}

          {getLessonInfo(lesson).length > 0 && <div className='fs-7 fw-semibold text-gray-600 pt-1'>
            {getLessonInfo(lesson).join(' • ')}
          </div>}
        </div>

        <div className='d-flex flex-column align-items-end flex-shrink-0'>
          <span className='fs-7 fw-semibold text-gray-600 text-end'>
            {attributes.occupied_spots} {attributes.occupied_spots === 1 ? 'jogador' : 'jogadores'}
          </span>

          {attributes.has_available_spots && <span className='fs-6 fw-bold text-primary text-end'>
            {attributes.available_spots} {attributes.available_spots === 1 ? 'vaga livre' : 'vagas livres'}
          </span>}

          {!attributes.has_available_spots && <span className='fs-6 fw-bold text-gray-600 text-end'>
            Turma cheia
          </span>}

          {onClick && <i className='las la-angle-right fs-2x text-primary mt-2'></i>}
        </div>
      </div>

      {(attributes.is_participant || attributes.accepts_makeup_class) && <div className='d-flex flex-wrap gap-2 pt-3'>
        {attributes.is_participant && !attributes.is_absent && <span className='badge badge-light-success fs-7'>
          Você participa
        </span>}

        {attributes.uses_makeup_credit && <span className='badge badge-light-warning fs-7'>
          Usando crédito de reposição
        </span>}

        {attributes.is_absent && <span className='badge badge-light-danger fs-7'>
          Falta marcada
        </span>}

        {attributes.accepts_makeup_class && <span className='badge badge-light-primary fs-7'>
          Aceita reposição
        </span>}
      </div>}

      {children}
    </div>
  );
}

export {
  getLessonInfo,
};

export default LessonItem;
